export const IS_LOADING = "IS_LOADING";
export const USERS_LOADING = "USERS_LOADING";
export const USER_DATA_LOADING = "USER_DATA_LOADING";
export const ALL_STORES = "ALL_STORES";
export const FETCHED_RECORD = "FETCHED_RECORD";
export const STORE_ADDED = "STORE_ADDED";
export const UPDATE_GALLERY = "UPDATE_GALLERY";
export const ADMIN_ROLES = "ADMIN_ROLES";
export const OFFICES = "OFFICES";
export const APPROVERS = "APPROVERS";
export const USERS = "USERS";
export const TOGGLE_USER_STATUS = "TOGGLE_USER_STATUS";
export const UPDATE_PROFILE_IMAGE = "UPDATE_PROFILE_IMAGE";
export const DEPARTMENTS = "DEPARTMENTS";